function usePromise() {
    const promiseFunc = resolve => str => resolve(str);
    const resolveFunc = {
        func: null,
    };
    const promiseInstance = async () => await new Promise((resolve, reject) => {
        resolveFunc.func = promiseFunc(resolve);
    })
    const clearResolveFunc = () => {
        resolveFunc.func = null;
    }

    return {
        promiseInstance,
        resolveFunc,
        clearResolveFunc,
    }
}

export default usePromise;
